import {
  aboutUsBg,
  ceoAvatar,
} from "../../../assets";
import { getStrapiMedia } from "../../../helpers/tranformers";
import SectionWithBackground from "../../SectionWithBackground";
import { Card, Button, Row, Col, Flex } from "antd";
import { useMediaQuery } from "react-responsive";
const AboutUs = ({ content }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  return (
    <SectionWithBackground background={aboutUsBg}>
      <div className="section-content mobile-padding-all">
        <Row align={"middle"} justify={"space-between"}>
          {!isMobile && (
            <Col md={10} data-aos="fade-right" data-aos-duration="700" s>
              <div className="about-us-main-img">
                <img
                  src={getStrapiMedia(content?.Image?.url)}
                  alt=""
                  style={{ width: "100%", height: "100%" }}
                />
              </div>{" "}
            </Col>
          )}
          <Col md={12} sm={12} data-aos="fade-left" data-aos-duration="700">
            <div
              className="about-section-heading"
              style={{ textAlign: isMobile ? "center" : "left" }}
            >
              {content?.Heading}
            </div>
            <div
              className="section-heading "
              style={{
                marginBottom: isMobile ? "30px" : "42px",
                textAlign: isMobile ? "center" : "left",
              }}
            >
              {content?.Title}{" "}
            </div>
            <div
              className="card-content-text"
              style={{ textAlign: isMobile ? "center" : "left" }}
            >
              {content?.Description}
            </div>
            {!isMobile ? (
              <div className="content-without-heading">
                <Row>
                  {content?.points?.map((point, index) => {
                    return (
                      <Col xs={24} md={24} key={point?.id}>
                        <div>
                          <div className="about-us-points ">
                            <img src={getStrapiMedia(point?.Image?.url)} className="point-image" />
                            <div>
                              <div className="card-title">{point?.Title}</div>
                              <div className="card-content-text">
                                {point?.Description}
                              </div>
                            </div>
                          </div>
                        </div>
                      </Col>
                    );
                  })}
                  {/* <Col xs={24} md={24}>
                    <div>
                      <div className="about-us-points ">
                        <img src={aboutUs1} className="point-image" />
                        <div>
                          <div className="card-title">Problem Solving</div>
                          <div className="card-content-text">
                            Streamlining operations, driving growth with
                            tailored solutions.
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>

                  <Col xs={24} md={24}>
                    <div>
                      <div className="about-us-points ">
                        <img src={aboutUs2} className="point-image" />
                        <div>
                          <div className="card-title">Mission & Vision</div>
                          <div className="card-content-text">
                            Leading technology to champion our business
                            partners.
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col> */}
                </Row>

                {/* Profile Section */}
                <Row style={{ marginTop: "50px" }}>
                  {/* <Button shape="round" className="explore-btn">
                    EXPLORE MORE
                  </Button> */}
                  <div className="about-us-points ceo-info">
                    <img
                      src={ceoAvatar}
                      alt="Rajiv Upadhyay"
                      className="ceo-avatar"
                    />
                    <div>
                      <p
                        style={{
                          fontWeight: "bold",
                          margin: 0,
                          fontSize: "20px",
                        }}
                      >
                        Rajiv Upadhyay
                      </p>
                      <span style={{ color: "#888", fontSize: "18px" }}>
                        CEO, Founder
                      </span>
                    </div>
                  </div>
                </Row>
              </div>
            ) : (
              <center>
                {/* <Button
                  size="large"
                  shape="round"
                  className="explore-btn mb-30 mt-30"
                >
                  EXPLORE MORE
                </Button> */}
              </center>
            )}
          </Col>
          {isMobile && (
            <Col md={12}>
              <div className="about-us-main-img">
                <img
                  src={getStrapiMedia(content?.Image?.url)}
                  alt=""
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                />
              </div>{" "}
            </Col>
          )}
        </Row>
      </div>
    </SectionWithBackground>
  );
};
export default AboutUs;
